import { Component, ElementRef, QueryList, ViewChildren } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { GsapService } from '../../../shared/animations/gsap.service';
import { Offer } from '../../../shared/data/models/collections/offer';
import { Request } from '../../../shared/data/services/request-enum';
import { AbstractLocalizedComponent } from '../../../shared/ui/abstract.localized.component';

@Component({
  selector: 'placeme-offer',
  templateUrl: './offer.component.html',
  styleUrls: ['./offer.component.scss'],
})
export class OfferComponent extends AbstractLocalizedComponent {
  offer: Offer;

  @ViewChildren('revealContainer') set revealContainerRef(revealContainerRef: QueryList<ElementRef<HTMLElement>>) {
    const revealContainers = revealContainerRef.map(e => e.nativeElement);
    if (revealContainers.length) {
      revealContainers.forEach((element: HTMLElement) => {
        const revealElements: NodeListOf<Element> = element?.querySelectorAll('.reveal');
        const stagger = revealElements.length >= 3 ? 0.1 : 0.2;
        this.gsapService.set(revealElements, { opacity: 0, scale: 0.9 });
        this.gsapService.createScrollTrigger({
          trigger: element,
          start: 'top 60%',
          onEnter: () =>
            this.gsapService.timeline().to(revealElements, {
              opacity: 1,
              scale: 1,
              duration: 0.2,
              stagger,
              ease: this.gsapService.easeInOut(),
            }),
          once: true,
        });
      });
    }
  }

  constructor(
    private activatedRoute: ActivatedRoute,
    private gsapService: GsapService
  ) {
    super();
  }

  protected loadData(locale: string): void {
    this.collectionsService
      .query<{ offerBySlug: Offer }>(Request.OFFER, {
        slug: this.activatedRoute.snapshot.params.slug,
        locale,
      })
      .subscribe(data => (this.offer = data.offerBySlug));
  }
}
